/** Max video upload size for academy/community full-match footage. */
export const MAX_VIDEO_UPLOAD_GB = 20;
export const MAX_VIDEO_UPLOAD_BYTES = MAX_VIDEO_UPLOAD_GB * 1024 * 1024 * 1024;

/** AWS S3 single PUT (presigned) max object size — larger files must use multipart. */
export const S3_SINGLE_PUT_MAX_BYTES = 5 * 1024 * 1024 * 1024;

/**
 * Browser uploads switch to multipart below the 5GB AWS PUT limit.
 * ~60MB single PUTs work on production; multi-hundred-MB/GB files are the risk.
 */
export const S3_BROWSER_MULTIPART_THRESHOLD_BYTES = 256 * 1024 * 1024;

/** Multipart part size. Must be at least 5 MB except the last part. */
export const MULTIPART_PART_SIZE_BYTES = 32 * 1024 * 1024;

/** Parallel S3 part uploads. 3 keeps Safari/mobile stable on large files. */
export const MULTIPART_CONCURRENCY = 3;

export function getVideoFileSizeGB(file) {
  return file.size / (1024 * 1024 * 1024);
}

export function validateVideoFileSize(file) {
  const fileSizeGB = getVideoFileSizeGB(file);
  if (fileSizeGB > MAX_VIDEO_UPLOAD_GB) {
    throw new Error(
      `File is too large (${fileSizeGB.toFixed(2)}GB). Maximum file size is ${MAX_VIDEO_UPLOAD_GB}GB.`
    );
  }
}

export function maxVideoUploadLabel() {
  return `${MAX_VIDEO_UPLOAD_GB}GB`;
}
